import { StoreState } from '../store-interfaces';

export const selectSignalConfiguration = (state: StoreState) =>
  state.signalConfiguration.configuration;

export const selectSignalEvents = (state: StoreState) =>
  state.signalConfiguration.events;

export const selectSignalEventsByDay = (state: StoreState) =>
  state.signalConfiguration.eventsByDay;
